import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { accountsAtom, type EnergyLinkAccount } from './atoms';

export interface EnergyLinkAccessState {
  hasAccess: boolean;
  accounts: EnergyLinkAccount[];
  isLoading: boolean;
  error?: string;
}

export const useEnergyLinkAccess = (): EnergyLinkAccessState => {
  const [accounts, getAccounts] = useAtom(accountsAtom);

  useEffect(() => {
    if (!accounts.initialized && !accounts.loading && !accounts.error) {
      getAccounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAccounts]);

  return {
    // Consider access denied if there's an error
    hasAccess: accounts.initialized && !accounts.error,
    accounts: accounts.results,
    isLoading: accounts.loading,
    error: accounts.error?.message,
  };
};
